export default "__VITE_ASSET__06OAP6e8__"